<template>
  <div class="sld_order_detail">
    <MemberTitle memberTitle="订单详情" memberTitle_two="客户订单" memberTitle_two_path="/member/connection/connection_order">
    </MemberTitle>
    <div class="container">
      <div class="top_info flex_row_start_center">
        <div class="top_info_state flex_column_center_center">
          <p class="state">{{ order_info.data.orderStateValue }}</p>
          <p v-if="order_info.data.orderState == 0 && order_info.data.payState == 0 || order_info.data.orderState == 0 && order_info.data.payState == 1"
            class="refuse_reason">
            {{ order_info.data.refuseReason }}
          </p>

          <p class="refuse_reason"
            v-if="order_info.data.orderType == 103 && order_info.data.orderSubState == 102 && !(order_info.data.presellInfo && order_info.data.presellInfo.isStartRemainPay)">
            {{ order_info.data.presellInfo.remainStartTime }}{{ L['开始付尾款'] }}</p>
            <p class="cancel flex_row_center_center" v-if="afsState">
            
            <span class="pointer"
              v-if="(order_info.data.orderState == 10 || order_info.data.orderState == 20) && order_info.data.isVirtualGoods == 1"
              @click="editAddress(order_info.data.orderSn,order_info.data.memberId)">{{ L['修改地址'] }}</span>
          </p>
        </div>
        <!-- 正常订单 -->
        <div v-if="order_info.data.orderState != 0&&order_info.data.orderState != 12" class="top_info_progress flex_row_center_center">
          <div class="progress_item">
            <p>{{ L['提交订单'] }}</p>
            <div class="progress flex_row_center_center">
              <span :class="{ active: order_info.data.orderLogList && order_info.data.orderLogList.length >= 1 }">1</span>
              <div class="progress_line">
                <div
                  :class="{ content: true, active: order_info.data.orderLogList && order_info.data.orderLogList.length >= 1, current: order_info.data.orderLogList && order_info.data.orderLogList.length == 1 }">
                </div>
              </div>
            </div>
          </div>
          <div class="progress_item" >
            <p>支付订单</p>
            <div class="progress flex_row_center_center">
              <span :class="{ active: order_info.data.orderLogList && order_info.data.orderLogList.length >= 2 }">2</span>
              <div class="progress_line">
                <div
                  :class="{ content: true, active: order_info.data.orderLogList && order_info.data.orderLogList.length >= 2, current: order_info.data.orderLogList && order_info.data.orderLogList.length == 2 }">
                </div>
              </div>
            </div>
          </div>
          <div class="progress_item" v-if="order_info.data.paymentCode == 'OFFLINE'">
            <p>收款审核</p>
            <div class="progress flex_row_center_center">
              <span :class="{ active: order_info.data.orderLogList && order_info.data.orderLogList.length >= 3 }">3</span>
              <div class="progress_line">
                <div
                  :class="{ content: true, active: order_info.data.orderLogList && order_info.data.orderLogList.length >= 3, current: order_info.data.orderLogList && order_info.data.orderLogList.length == 3 }">
                </div>
              </div>
            </div>
          </div>
           <div class="progress_item">
            <p>订单审核</p>
            <div class="progress flex_row_center_center">
              <span :class="{ active: order_info.data.orderLogList && order_info.data.orderLogList.length >= (order_info.data.paymentCode == 'OFFLINE'?4:3) }">{{order_info.data.paymentCode == 'OFFLINE'?4:3}}</span>
              <div class="progress_line">
                <div
                  :class="{ content: true, active: order_info.data.orderLogList && order_info.data.orderLogList.length >= (order_info.data.paymentCode == 'OFFLINE'?4:3), current: order_info.data.orderLogList && order_info.data.orderLogList.length == (order_info.data.paymentCode == 'OFFLINE'?4:3) }">
                </div>
              </div>
            </div>
          </div>
          
          <div class="progress_item">
            <p>{{ L['商家发货'] }}</p>
            <div class="progress flex_row_center_center">
              <span :class="{ active: order_info.data.orderLogList && order_info.data.orderLogList.length >= (order_info.data.paymentCode == 'OFFLINE'?5:4) }">{{order_info.data.paymentCode == 'OFFLINE'?5:4}}</span>
              <div class="progress_line">
                <div
                  :class="{ content: true, active: order_info.data.orderLogList && order_info.data.orderLogList.length >= (order_info.data.paymentCode == 'OFFLINE'?5:4), current: order_info.data.orderLogList && order_info.data.orderLogList.length == (order_info.data.paymentCode == 'OFFLINE'?5:4) }">
                </div>
              </div>
            </div>
          </div>
          <div class="progress_item">
            <p>{{ L['确认收货'] }}</p>
            <div class="progress flex_row_center_center" style="margin-left: -31px;">
              <span :class="{ active: order_info.data.orderLogList && order_info.data.orderLogList.length >= (order_info.data.paymentCode == 'OFFLINE'?6:5) }">{{order_info.data.paymentCode == 'OFFLINE'?6:5}}</span>
            </div>
          </div>
        </div>
        <!-- 交易关闭订单 -->
        <div v-if="order_info.data.orderState == 0||order_info.data.orderState == 12" class="top_info_progress flex_row_center_center">
          <div class="progress_item">
            <p>{{ L['提交订单'] }}</p>
            <div class="progress flex_row_center_center">
              <span :class="{ active: order_info.data.orderLogList && order_info.data.orderLogList.length >= 1 }">1</span>
              <div class="progress_line">
                <div
                  :class="{ content: true, active: order_info.data.orderLogList && order_info.data.orderLogList.length >= 1, current: order_info.data.orderLogList && order_info.data.orderLogList.length == 1 }">
                </div>
              </div>
            </div>
          </div>
          <div class="progress_item">
            <p>{{ L['交易关闭'] }}</p>
            <div class="progress flex_row_start_center">
              <span class="active">2</span>
            </div>
          </div>
        </div>
      </div>


      <!-- 包裹信息 -->
      <div class="wrap_content"
        v-if="order_info.data.orderDelivers && order_info.data.deliverType == 0 && order_info.data.orderDelivers.length > 0">
        <div class="wrap_tab_list" v-if="!((order_info.data.orderState == 30 || order_info.data.orderState == 40) && order_info.data.orderDelivers.length == 1)">
          <div class="tab_item">
            <text @click="changeWrapTab(item, index)" :class="currentTab == index ? 'active' : ''"
              v-for="(item, index) in order_info.data.orderDelivers" :key="index">包裹{{ index + 1 }}</text>
          </div>
        </div>
        <!-- 包裹具体信息 -->
        <div class="wrap_detail">
          <div class="detail_left">
            <div class="detail_top" v-for="(item, index) in logistics_info.data.deliverOrdersProducts" :key="index">
              <div class="top_left">
                <img :src="item.productImage" alt="">
              </div>
              <div class="top_right flex_column_between_start">
                <div class="good_tit">{{ item.goodsName }}</div>
                <div class="good_num">发货数量：{{ item.deliverNum }}</div>
              </div>
            </div>
            <div class="detail_next">
              <div class="next_info">
                <text>物流公司：</text>
                <text>{{ logistics_info.data.expressName ? logistics_info.data.expressName : '--' }}</text>
              </div>
              <div class="next_info">
                <text>物流单号：</text>
                <text>{{ logistics_info.data.expressNumber ? logistics_info.data.expressNumber : '--' }}</text>
              </div>
            </div>
          </div>
          <div class="detail_right">
            <div  class="logistics_info_right">
              <div class="right_container">
                <img v-if="!logistics_info_Trace.data.routeList || logistics_info_Trace.data.routeList.length == 0" :src="express_empty" alt />
                <p v-if="!logistics_info_Trace.data.routeList || logistics_info_Trace.data.routeList.length == 0">{{ L['暂无物流信息'] }}</p>
                <el-timeline v-if="logistics_info_Trace.data.routeList && logistics_info_Trace.data.routeList.length > 0">
                  <el-timeline-item v-for="(logistics, index) in logistics_info_Trace.data.routeList" :key="index"
                    :timestamp="logistics.remark">{{ logistics.acceptTime }}</el-timeline-item>
                </el-timeline>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="order_info">
        <p>{{ L['订单信息'] }}</p>
        <div class="left">
          <div class="order_info_item">
            <div>
              <span>{{ L['订单号'] }}：</span>
              {{ order_info.data.orderSn }}
            </div>
          </div>
          <div class="order_info_item">
            <div>
              <span>{{ L['下单时间'] }}：</span>
              {{ order_info.data.createTime }}
            </div>
          </div>
          <div class="order_info_item" v-if="order_info.data.isVirtualGoods == 1">
            <div class="overflow_ellipsis_two"
              :title="(order_info.data.receiverAreaInfo || '') + order_info.data.receiverAddress">
              <span>{{ L['收货地址'] }}：</span>
              {{ order_info.data.receiverAreaInfo }} {{ order_info.data.receiverAddress }}
            </div>
          </div>
          <div class="order_info_item" v-if="order_info.data.isVirtualGoods == 1">
            <div>
              <span>{{ L['收货人信息'] }}：</span>
              {{ order_info.data.receiverName }} {{ order_info.data.receiverMobile }}
            </div>
          </div>
        </div>
        <div class="left">
          <div class="order_info_item">
            <div>
            <!-- <span>{{ L['发票'] }}：</span> -->
              <span>抬头发票：</span>
              {{ order_info.data.invoice ? order_info.data.invoice.invoiceTitle : L['不需要发票'] }}
            </div>
          </div>
          <div class="order_info_item">
            <div>
              <!-- <span>{{ L['发票抬头'] }}：</span>
                  {{ order_info.data.invoice ? order_info.data.invoice.invoiceTitle : '--' }} -->
              <span>电子邮箱：</span>
              {{ order_info.data.invoiceEmail }}
            </div>
          </div>
        <div class="order_info_item">
          <div>
            <span>跟单销售：</span>
              {{ order_info.data.saleTrueName ? order_info.data.saleTrueName : '--' }}
            </div>
          </div>
          <div class="order_info_item flex">
            <!-- <div>
                    <span>{{ L['交易流水号'] }}：</span>
                    {{ order_info.data.tradeSn }}
                  </div> -->
            <div>
              <span>开票状态：</span>
              {{ order_info.data.invoiceStatusValue }}
            </div>
          </div>
        </div>



        <div v-if="order_info.data.isVirtualGoods == 2 && order_info.data.orderReserveList.length">
          <div class="order_info_item" v-for="(item, index) in order_info.data.orderReserveList"
            v-show="item.reserveValue" :key="index">
            <div>
              <span>{{ item.reserveName }}：</span>
              {{ item.reserveValue }}
            </div>
          </div>
        </div>


      </div>


      <!-- <div class="order_info">
        <p>{{ L['订单信息'] }}</p>
        <div class="order_info_item flex">
          <div>
            <span>{{ L['订单号'] }}：</span>
            {{ order_info.data.orderSn }}
          </div>
          <div>
            <span>抬头发票：</span>
            {{ order_info.data.invoice ? order_info.data.invoice.invoiceTitle : L['不需要发票'] }}
          </div>
        </div>
        <div class="order_info_item flex">
          <div>
            <span>{{ L['下单时间'] }}：</span>
            {{ order_info.data.createTime }}
          </div>
          <div>
            <span>电子邮箱：</span>
            {{ order_info.data.invoiceEmail }}
          </div>
        </div>
        <div class="order_info_item flex" v-if="order_info.data.isVirtualGoods == 1">
          <div class="overflow_ellipsis_two"
            :title="(order_info.data.receiverAreaInfo || '') + order_info.data.receiverAddress">
            <span>{{ L['收货地址'] }}：</span>
            {{ order_info.data.receiverAreaInfo }} {{ order_info.data.receiverAddress }}
          </div>
          <div>
            <span>跟单销售：</span>
            {{ order_info.data.saleTrueName }}
          </div>
        </div>
        <div class="order_info_item" v-if="order_info.data.isVirtualGoods == 1">
          <div>
            <span>{{ L['收货人信息'] }}：</span>
            {{ order_info.data.receiverName }} {{ order_info.data.receiverMobile }}
          </div>
        </div>
        <div class="order_info_item" v-if="order_info.data.tradeSn">
          <div>
            <span>开票状态：</span>
            已开票
          </div>
        </div>

        <div v-if="order_info.data.isVirtualGoods == 2 && order_info.data.orderReserveList.length">
          <div class="order_info_item" v-for="(item, index) in order_info.data.orderReserveList"
            v-show="item.reserveValue" :key="index">
            <div>
              <span>{{ item.reserveName }}：</span>
              {{ item.reserveValue }}
            </div>
          </div>
        </div>


      </div> -->
      <div class="order_mark">
        <p>{{ order_info.data.orderState == 0 && order_info.data.payState == 1 ? L['订单取消备注'] : L['订单备注'] }}</p>
        <div class="order_mark_item" v-if="order_info.data.orderState == 0 && order_info.data.payState == 1">
          <span>{{ order_info.data.refuseRemark ? order_info.data.refuseRemark : '--' }}</span>
        </div>
        <div class="order_mark_item" v-else>
          <span>{{ order_info.data.remark ? order_info.data.remark : '--' }}</span>
        </div>
      </div>

        <!-- 新增：销售备注模块 -->
      <div class="order_mark sale_remark_block">
        <p class="flex_row_between_center">
          <span>{{ L['销售备注'] }}</span>
            <span 
            v-if="order_info.data.canEditSaleRemark" 
            class="edit_btn pointer" 
            style="color:blue; font-size: 14px;" 
            @click="handleEditSaleRemark"
          >
            {{ L['编辑'] }}
          </span>
        </p>
        <div class="order_mark_item">
          <div class="remark-content">{{ saleRemarkInfo.content || '--' }}</div>
          <div class="remark-time" v-if="saleRemarkInfo.time">
            {{ L['备注时间'] }}：{{ saleRemarkInfo.time }}
          </div>
        </div>
      </div>
      <!-- 新增：销售备注模块结束 -->

      <!-- 新增：会员订单附加信息模块 -->
      <div class="order_info">
        <!-- 标题（复用 order_info 标题样式，右侧加编辑按钮） -->
        <p class="extend_title flex_row_between_center">
          {{ L['会员订单附加信息'] }}
          <span class="edit_btn pointer" style="color:blue;" @click="handleEditExtend">{{ L['编辑'] }}</span>
        </p>

        <div class="left">
          <div class="order_info_item">
            <div>
              <span>{{ L['终端'] }}：</span>
              {{ order_info.data.terminal  || '--' }}
            </div>
          </div>
          <div class="order_info_item">
            <div>
              <span>{{ L['终端(自定义)'] }}：</span>
              {{ order_info.data.distributor  || '--' }}
            </div>
          </div>
          <div class="order_info_item">
            <div>
              <span>{{ L['课题组'] }}：</span>
              {{ order_info.data.researchGroup || '--'  }}
            </div>
          </div>
        </div>
        <div class="left">
          <div class="order_info_item">
            <div>
              <span>{{ L['PI'] }}：</span>
              {{ order_info.data.pi  || '--' }}
            </div>
          </div>
          <div class="order_info_item">
            <div>
              <span>{{ L['使用人'] }}：</span>
              {{ order_info.data.user  || '--' }}
            </div>
          </div>
        </div>
      </div>
      <!-- 新增：会员订单附加信息模块结束 -->

      <div class="shop_info" v-if="order_info.data.orderProductList">
        <p>{{ L['商品信息'] }}</p>
        <div class="shop_title flex">
          <div class="detail">{{ L['商品详情'] }}</div>
          <div class="price">{{ L['单价'] }}</div>
          <div class="num">货号</div>
          <div class="num">{{ L['数量'] }}</div>
          <div
            v-if="order_info.data.orderState == 20 || order_info.data.orderState == 30 || order_info.data.orderState == 40"
            class="oprate">{{ L['操作'] }}</div>
        </div>

        <div v-for="(goodItem, index) in order_info.data.orderProductList" :key="index" class="good_item flex">
          <div class="good_info flex">
            <div class="image flex_row_center_center">
              <coverImage :src='goodItem.productImage' width="64" height="64"></coverImage>

            </div>
            <div class="good_info_con">
              <router-link :to="`/goods/detail?productId=${goodItem.productId}`" class="name" target="_blank">
                <span class="gift" v-if="goodItem.isGift == 1">{{ L['赠品'] }}</span>{{ goodItem.goodsName }}
              </router-link>
              <div class="spec">{{ goodItem.goodsCode }}-{{ goodItem.specInfo }}</div>
              <div class="company">{{ order_info.data.subjectName }}</div>

            </div>
          </div>
          <div class="price flex_row_center_center">{{ goodItem.productShowPrice }}</div>
          <div class="num flex_row_center_center">{{ order_info.data.goodsCode }}</div>
          <div class="num flex_row_center_center">*{{ goodItem.productNum }}</div>
          <div
            v-if="order_info.data.orderState == 20 || order_info.data.orderState == 30 || order_info.data.orderState == 40"
            class="oprate flex_row_center_center">
            <!-- 退款中 可查看退款详情  售后按钮，100-退款（商家未发货），200-退款（商家发货,买家未收货），300-申请售后，401-退款中，402-退款完成,403-换货中，404-换货完成	301,退款失败-平台审核失败-->
            <!-- <span class="refund_btn pointer "
              v-if="(goodItem.afsButton == 401 || goodItem.afsButton == 402 || goodItem.afsButton == 403 || goodItem.afsButton == 404 || goodItem.afsButton == 301) && goodItem.isGift == 0"
              @click.stop="goRefundDetail(goodItem.afsSn)">{{ goodItem.afsButtonValue }}</span> -->
            <!-- 退款 可申请退款-->
            <!-- <span class="refund_btn pointer"
              v-if="(goodItem.afsButton == 100 || goodItem.afsButton == 200 || goodItem.afsButton == 300) && goodItem.isGift == 0"
              @click.stop="selectService(goodItem.orderProductId, order_info.data.orderSn)">{{
                goodItem.afsButtonValue
              }}</span> -->

            <!-- 赠品不能申请售后 -->
            <!-- <span class="refund_btn" v-if="goodItem.isGift == 1">--</span> -->
            <span class="refund_btn">--</span>

          </div>
        </div>
      </div>
    </div>
    <!-- 取消地址理由弹窗 start -->
    <el-dialog :title="L['取消订单理由']" v-model="cancel_order" customClass="select_reason_width" :before-close="handleClose"
      lock-sroll="false">
      <div class="cancel_list_con">
        <div v-for="(reasonItem, index) in cancel_list.data" :key="index"
          :class="{ reason_item: true, flex_row_between_center: true, active: current_reason_id == reasonItem.reasonId }"
          @click="selectReason(reasonItem.reasonId)">
          <span class="reason_text">{{ reasonItem.content }}</span>
          <img :src="current_reason_id == reasonItem.reasonId ? selected : not_select" alt />
        </div>
      </div>
      <div class="confirm_cancel_btn" @click="confirmCancel()">{{ L['确定'] }}</div>
    </el-dialog>
    <!--  取消地址理由弹窗 end  -->
    <!-- 地址选择弹窗 start -->
    <el-dialog :title="L['更换地址']" v-model="show_select_address" customClass="select_address_width"
      :before-close="handleClose" lock-sroll="false">
      <div class="out_stock_dialog address_con">
        <div v-for="(item, index) in address_list.data" :key="index" @click="selectAddress(index)"
          :class="{ address_item: true, flex_column_start_start: true, select: current_address_index == index }">
          <span>{{ L['收货人'] }}：{{ item.memberName }}</span>
          <span>{{ L['联系方式'] }}：{{ item.telMobile }}</span>
          <span class="address_text">
            <div>{{ L['收货地址'] }}：</div>
            <div>{{ item.addressAll }} {{ item.detailAddress }}</div>
          </span>
          <img v-if="current_address_index == index" class="selected" :src="invoice_selected" alt />
        </div>
      </div>
      <div class="btn_con flex_row_center_center">
        <div class="confirm_cancel_btn" @click="confirmChangeAddress()">{{ L['提交修改'] }}</div>
      </div>
    </el-dialog>
    <!-- 地址选择弹窗 end -->

    <!-- 新增：编辑会员订单附加信息弹层 -->
    <el-dialog 
      :title="L['编辑会员订单附加信息']" 
      v-model="showEditExtendDialog" 
      customClass="extend_edit_dialog" 
      :before-close="handleCloseExtendDialog"
      lock-scroll="false"
    >
      <div class="dialog_form">
        <!-- 终端输入框 -->
        <!-- <div class="form_item flex_row_start_center">
          <label class="form_label">{{ L['终端'] }}：</label>
          <el-input 
            v-model="form.terminal" 
            :placeholder="L['请输入终端']" 
            maxlength="50" 
            clearable
          ></el-input>
        </div> -->
        <!-- 终端(自定义)输入框 -->
        <div class="form_item flex_row_start_center">
          <label class="form_label">{{ L['终端(自定义)'] }}：</label>
          <el-input 
            v-model="form.distributor" 
            :placeholder="L['请输入终端(自定义)']" 
            maxlength="50" 
            clearable
          ></el-input>
        </div>
        <!-- 课题组输入框 -->
        <div class="form_item flex_row_start_center">
          <label class="form_label">{{ L['课题组'] }}：</label>
          <el-input 
            v-model="form.researchGroup" 
            :placeholder="L['请输入课题组']" 
            maxlength="50" 
            clearable
          ></el-input>
        </div>
        <!-- PI输入框 -->
        <div class="form_item flex_row_start_center">
          <label class="form_label">{{ L['PI'] }}：</label>
          <el-input 
            v-model="form.pi" 
            :placeholder="L['请输入PI']" 
            maxlength="50" 
            clearable
          ></el-input>
        </div>
        <!-- 使用人输入框 -->
        <div class="form_item flex_row_start_center">
          <label class="form_label">{{ L['使用人'] }}：</label>
          <el-input 
            v-model="form.user" 
            :placeholder="L['请输入使用人']" 
            maxlength="50" 
            clearable
          ></el-input>
        </div>
      </div>
      <!-- 底部按钮（复用现有弹窗按钮样式） -->
      <div class="btn_con flex_row_center_center">
        <div class="cancel_btn pointer" @click="showEditExtendDialog = false">{{ L['取消'] }}</div>
        <div class="confirm_btn pointer" @click="confirmUpdateExtend">{{ L['确定'] }}</div>
      </div>
    </el-dialog>
    <!-- 新增：编辑附加信息弹层结束 -->
  </div>

  <!-- 新增：编辑销售备注弹层 -->
    <el-dialog 
      :title="L['编辑销售备注']" 
      v-model="showEditSaleRemarkDialog" 
      customClass="extend_edit_dialog" 
      :before-close="handleCloseSaleRemarkDialog"
      lock-scroll="false"
    >
      <div class="dialog_form">
        <div class="form_item flex_column_start_start">
          <!-- <label class="form_label">{{ L['备注内容'] }}：</label> -->
          <el-input 
            v-model="saleRemarkForm.content" 
            type="textarea"
            :rows="4"
            :placeholder="L['请输入销售备注']" 
            maxlength="500" 
            show-word-limit
          ></el-input>
        </div>
      </div>
      <!--底部按钮-->
      <div class="btn_con flex_row_center_center">
        <div class="cancel_btn pointer" @click="showEditSaleRemarkDialog = false">{{ L['取消'] }}</div>
        <div class="confirm_btn pointer" @click="confirmUpdateSaleRemark">{{ L['确定'] }}</div>
      </div>
    </el-dialog>
    <!-- 新增：编辑销售备注弹层结束 -->
</template>
<script>
import { useStore } from "vuex";
import { reactive, getCurrentInstance, ref, onMounted } from "vue";
import {
  elBreadcrumb,
  elBreadcrumbItem,
  ElMessage,
  ElDialog,
  ElMessageBox,
  ElTimeline,
  ElTimelineItem
} from "element-plus";

import { useRouter, useRoute } from "vue-router";
import MemberTitle from "../../../components/MemberTitles";

export default {
  name: "order-detail",
  components: {
    elBreadcrumb,
    elBreadcrumbItem,
    ElDialog,
    ElTimeline,
    ElTimelineItem,
    MemberTitle
  },
  setup() {
    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const { proxy } = getCurrentInstance();
    const L = proxy.$getCurLanguage();
    const order_info = reactive({ data: {} });
    const express_empty = require("../../../assets/order/express_empty.png");
    const not_select = require("../../../assets/order/not_select.png");
    const selected = require("../../../assets/order/selected.png");
    const invoice_selected = require("../../../assets/buy/invoice_selected.png");
    const cancel_list = reactive({ data: [] });
    const cancel_order = ref(false); //是否显示取消订单弹窗
    const current_reason_id = ref(); //记录当前已选择理由id
    const order_sn = ref(""); //记录当前操作的订单号
    const memberId = ref("");
    const show_select_address = ref(false); //是否显示选择地址弹窗
    const address_list = reactive({ data: [] }); //地址列表
    const current_address_index = ref(0); //记录当前选择的地址
    const logistics_info = reactive({ data: {} }); //物流信息
    const afsState = ref(true)

    const currentTab = ref(0) //包裹索引

      // 新增：销售备注相关变量
    const showEditSaleRemarkDialog = ref(false); // 编辑弹层显示状态
    const saleRemarkInfo = reactive({
      content: '', // 备注内容
      time: ''     // 备注时间
    });
    const saleRemarkForm = reactive({
      content: '' // 表单中的备注内容
    });

    const logistics_info_Trace = reactive({ data: {} })
    // 新增：编辑会员订单附加信息相关变量
    const showEditExtendDialog = ref(false); // 编辑弹层显示状态
    const form = reactive({ // 编辑表单（绑定输入框）
      terminal: '',    // 终端
      distributor: '',    // 终端(自定义)
      researchGroup: '', // 课题组
      pi: '',          // PI
      user: ''         // 使用人
    });

    // 新增：打开编辑附加信息弹层
    const handleEditExtend = () => {
      // 同步最新数据到表单（避免弹层显示旧数据）
      // form.terminal = order_info.data.terminal || '';
      form.distributor = order_info.data.distributor || '';
      form.researchGroup = order_info.data.researchGroup || '';
      form.pi = order_info.data.pi || '';
      form.user = order_info.data.user || '';
      showEditExtendDialog.value = true; // 显示弹层
    };

    // 新增：弹层关闭时重置表单（可选，避免下次打开残留旧数据）
    const handleCloseExtendDialog = () => {
      showEditExtendDialog.value = false;
      // 可选：重置表单
      // form.terminal = '';
      // form.distributor = '';
      // form.researchGroup = '';
      // form.pi = '';
      // form.user = '';
    };
    // 新增：确认更新会员订单附加信息
    const confirmUpdateExtend = () => {
      // 接口参数（orderSn 从订单详情取，表单值去空格）
      const params = {
        orderSn: order_info.data.orderSn,
        // terminal: form.terminal.trim(),
        distributor: form.distributor.trim(),
        researchGroup: form.researchGroup.trim(),
        pi: form.pi.trim(),
        user: form.user.trim()
      };

      proxy
        .$post("v3/business/front/orderOperate/updateMemberOrderExtend", params)
        .then(res => {
          if (res.state == 200) {
            ElMessage.success(L['更新成功']);
            showEditExtendDialog.value = false; // 关闭弹层
            getOrderDetail(); // 重新获取订单详情，刷新展示数据
          } else {
            proxy.$message.error(res.msg || '更新失败，请重试');
          }
        })
        .catch(() => {
          proxy.$message.error('网络异常，请检查网络后重试');
        });
    };
    

    const changeWrapTab = (item, index) => {
      if (index == currentTab.value) return
      currentTab.value = index
      logistics_info.data = item
      lookLogistics(logistics_info.data.deliverId);
    }

    const getOrderDetail = () => {
      proxy
        .$post("v3/business/front/orderInfo/detail", {
          orderSn: route.query.orderSn,
          // orderType: 1
        }).then(res => {
          if (res.state == 200) {
            order_info.data = res.data;

            // 新增：初始化销售备注信息（从接口返回数据赋值）
            saleRemarkInfo.content = res.data.saleRemark || '';
            saleRemarkInfo.time = res.data.saleRemarkTime || '';


            // 新增：初始化会员订单附加信息（从接口返回数据赋值）
            const extendInfo = order_info.data.memberOrderExtendInfo || {};
            // form.terminal = order_info.data.terminal || '';
            form.researchGroup = order_info.data.researchGroup || '';
            form.distributor = order_info.data.distributor || '';
            form.pi = order_info.data.pi || '';
            form.user = order_info.data.user || '';

            // if ((order_info.data.orderState == 30 || order_info.data.orderState == 40) && order_info.data.isVirtualGoods == 1) {
            //   lookLogistics(order_info.data.orderSn);
            // }
            if (order_info.data.orderDelivers && order_info.data.orderDelivers.length != 0) {
              logistics_info.data = order_info.data.orderDelivers[0]
              lookLogistics(logistics_info.data.deliverId);
            }
            order_info.data.childOrdersVOS.map(child => {
              child.orderProductListVOList.map(item => {
                if (item.afsButton == 200 || item.afsButton == 201) {
                  afsState.value = false
                }
              })
            })
          } else {
            ElMessage.error(res.msg);
          }
        })
        .catch(() => {
          //异常处理
        });
    };
    // 获取订单取消理由列表
    const getCancelList = () => {
      proxy
        .$get("v3/system/front/reason/list", {
          type: 104
        })
        .then(res => {
          if (res.state == 200) {
            cancel_list.data = res.data;
          } else {
            ElMessage.error(res.msg);
          }
        })
        .catch(() => {
          //异常处理
        });
    };
    //选择理由
    const selectReason = id => {
      current_reason_id.value = id;
    };
    //显示选择理由弹窗
    const showSelectReasonDialog = orderSn => {
      if (!order_info.data.isRefundDeposit && (order_info.data.orderType == 105 || order_info.data.orderType == 103) && order_info.data.orderSubState == 102) {
        ElMessageBox.confirm(L['取消该订单定金不予退还,确定取消?'], L['提示'], {
          confirmButtonText: L['确定'],
          cancelButtonText: L['取消'],
          type: 'warning',
        }).then(() => {
          cancel_order.value = true;
          order_sn.value = orderSn;
        })
      } else {
        cancel_order.value = true;
        order_sn.value = orderSn;
      }

    };
    //确认取消订单
    const confirmCancel = () => {
      if (!current_reason_id.value) {
        ElMessage.warning(L['请选择取消理由']);
        return;
      }
      proxy
        .$post("v3/business/front/orderOperate/cancel", {
          parentSn: order_sn.value,
          reasonId: current_reason_id.value
        })
        .then(res => {
          if (res.state == 200) {
            ElMessage.success(L['取消订单成功']);
            cancel_order.value = false;
            getOrderDetail();
          } else {
            ElMessage.error(res.msg);
          }
        })
        .catch(() => {
          //异常处理
        });
    };
    //删除订单
    const delOrder = orderSn => {
      ElMessageBox.confirm(L['确认删除该订单?'], L['提示'], {
        confirmButtonText: L['确定'],
        cancelButtonText: L['取消'],
        type: "warning"
      })
        .then(() => {
          proxy
            .$post("v3/business/front/orderOperate/delete", {
              orderSn
            })
            .then(res => {
              if (res.state == 200) {
                ElMessage.success(L['删除订单成功']);
                router.go(-1);
              } else {
                ElMessage.error(res.msg);
              }
            })

        })
    };
    //确认收货
    const confirmReceipt = orderSn => {
      ElMessageBox.confirm(L['确认收货?'], L['提示'], {
        confirmButtonText: L['确定'],
        cancelButtonText: L['取消'],
        type: "warning"
      })
        .then(() => {
          proxy
            .$post("v3/business/front/orderOperate/receive", {
              orderSn
            })
            .then(res => {
              if (res.state == 200) {
                ElMessage.success(L['确认收货成功']);
                getOrderDetail();
              } else {
                ElMessage.error(res.msg);
              }
            })
            .catch(() => {
              //异常处理
            });
        })
        .catch(() => { });
    };
    //选择地址
    const editAddress = (orderSn,id) => {
        getAddressList(id)
        memberId.value = id;
      order_sn.value = orderSn;
    };
    //获取地址列表
    const getAddressList = (memberId) => {
      proxy
        .$get("v3/member/front/memberAddress/list",{memberId:memberId})
        .then(res => {
          if (res.state == 200) {
            address_list.data = res.data.list;
            show_select_address.value = true;
          } else {
            ElMessage.error(res.msg);
          }
        })
        .catch(() => {
          //异常处理
        });
    };
    //切换地址
    const selectAddress = index => {
      current_address_index.value = index;
    };
    //确认修改地址
    const confirmChangeAddress = () => {
      proxy
        .$post("v3/business/front/orderOperate/updateAddress", {
          orderSn: order_sn.value,
          addressId: address_list.data[current_address_index.value].addressId,
          memberId:memberId.value 
        })
        .then(res => {
            
          if (res.state == 200) {
            ElMessage.success('切换地址成功');
            show_select_address.value = false;
            getOrderDetail();
          } else {
            ElMessage.error(res.msg);
          }
        })
        .catch(() => {
          //异常处理
        });
    };
    //显示查看物流信息
    const lookLogistics = deliverId => {
      proxy
        .$get("v3/business/front/logistics/getTrace", {
          deliverId
        })
        .then(res => {
          if (res.state == 200) {
            logistics_info_Trace.data = res.data;
          } else {
            // ElMessage(res.msg);
          }
        })
        .catch(() => {
          //异常处理
        });
    };
    //评价订单
    const remainEvaluated = (orderSn) => {
      router.push({
        path: "/member/order/evaluate",
        query: {
          orderSn: orderSn,
        }
      });
    }
    //立即支付
    const goPay = orderSn => {
      router.push({
        path: "/buy/pay",
        query: {
          paySn: orderSn,
          payFrom: 2
        }
      });
    };
    //选择售后服务
    const selectService = (orderProductId, orderSn) => {

      proxy.$get('v3/business/front/after/sale/apply/applyInfo', {
        orderSn,
        orderProductId
      }).then(res => {
        if (res.state == 200) {
          router.push({
            path: "/member/order/refund/apply",
            query: {
              orderState: order_info.data.orderState,
              orderProductId
            }
          });
        } else {
          ElMessage.error(res.msg)
        }
      })



    }

     // 新增：打开编辑销售备注弹层
    const handleEditSaleRemark = () => {
      // 同步最新数据到表单
      saleRemarkForm.content = saleRemarkInfo.content || '';
      showEditSaleRemarkDialog.value = true;
    };

    // 新增：弹层关闭处理
    const handleCloseSaleRemarkDialog = () => {
      showEditSaleRemarkDialog.value = false;
    };

    // 新增：确认更新销售备注
    const confirmUpdateSaleRemark = () => {
      if (!saleRemarkForm.content.trim()) {
         ElMessage.warning(L['请输入备注内容']);
         return;
      }

      const params = {
        orderSn: order_info.data.orderSn,
        remark: saleRemarkForm.content.trim()
      };

      proxy
        .$post("v3/business/front/orderInfo/saleRemark", params)
        .then(res => {
          if (res.state == 200) {
            ElMessage.success(L['更新成功']);
            showEditSaleRemarkDialog.value = false;
            getOrderDetail(); // 重新获取订单详情以刷新显示
          } else {
            proxy.$message.error(res.msg || '更新失败，请重试');
          }
        })
        .catch(() => {
          proxy.$message.error('网络异常，请检查网络后重试');
        });
    };

    //查看售后详情
    const goRefundDetail = (afsSn) => {
      router.push({
        path: '/member/order/refund/detail',
        query: {
          orderState: order_info.data.orderState,
          afsSn
        }
      })
    }
    onMounted(() => {
      // 非销售员 登录进来之后跳转首页
      if (store.state.memberInfo.isSale == 0) {
        router.push({ path: "/index" });
      }
      getOrderDetail();
      getCancelList();
    //   getAddressList();
    });
    return {
      L,
      order_sn,
      memberId,
      order_info,
      express_empty,
      showSelectReasonDialog,
      cancel_list,
      current_reason_id,
      selectReason,
      cancel_order,
      not_select,
      selected,
      confirmCancel,
      delOrder,
      confirmReceipt,
      editAddress,
      confirmChangeAddress,
      confirmUpdateExtend,
      selectAddress,
      current_address_index,
      address_list,
      show_select_address,
      invoice_selected,
      logistics_info,
      remainEvaluated,
      selectService,
      goPay,
      goRefundDetail,
      afsState,

      // 新增
      currentTab,
      changeWrapTab,
      store,
      logistics_info_Trace,

      // 新增：会员订单附加信息相关
      showEditExtendDialog,
      form,
      handleEditExtend,
      handleCloseExtendDialog,
      // 新增：销售备注相关
      showEditSaleRemarkDialog,
      saleRemarkInfo,
      saleRemarkForm,
      handleEditSaleRemark,
      handleCloseSaleRemarkDialog,
      confirmUpdateSaleRemark
    };
  }
};
</script>
<style lang="scss">
@import "../../../style/member/connection_detail.scss";
 .cancel {
        position: absolute;
        bottom: 15px;
        span {
            display: inline-block;
            padding: 0 10px;
        }
        span:nth-child(2) {
            border-left: 1px solid #bbbbbb;
        }
        span:hover {
            color: $colorMain2;
        }
    }
  // 新增：会员订单附加信息模块样式
  .member_order_extend_info {
    margin: 15px 0;
    padding: 10px 0;
    border-bottom: 1px solid #f5f5f5;

    .extend_title {
      font-size: 16px;
      color: #333;
      margin-bottom: 15px;

      .edit_btn {
        color: $colorMain2; // 复用主题色
        font-size: 14px;
        cursor: pointer;

        &:hover {
          text-decoration: underline;
        }
      }
    }

    .extend_content {
      .order_info_item {
        margin-bottom: 8px;

        .field_item {
          width: 48%; // 2个字段一行，均分宽度

          .field_label {
            color: #666;
            margin-right: 8px;
          }

          .field_value {
            color: #333;
          }
        }
      }
    }
  }

// 新增：编辑附加信息弹层样式
.extend_edit_dialog {
  .dialog_form {
    padding: 10px 20px;

    .form_item {
      margin-bottom: 15px;
      width: 100%;
      display: flex;
      align-items: center;

      .form_label {
        width: 120px; // 增加label宽度
        text-align: right;
        margin-right: 10px;
        color: #666;
        flex-shrink: 0; // 防止label被压缩
      }

      .el-input {
        flex: 1; // 输入框占据剩余空间
        max-width: calc(100% - 130px); // 限制最大宽度
      }
    }
  }

  .btn_con {
    .cancel_btn {
      margin-right: 20px;
      padding: 6px 20px;
      border: 1px solid #ddd;
      border-radius: 4px;
      color: #666;

      &:hover {
        background: #f5f5f5;
      }
    }

    .confirm_btn {
      padding: 6px 20px;
      background: $colorMain2;
      color: #fff;
      border-radius: 4px;

      &:hover {
        background: #e63946; // 主题色hover效果
      }
    }
  }

// 新增：销售备注模块样式
.sale_remark_block {
  margin-top: 15px;
  width: 100%; // 确保块级元素占满父容器
  box-sizing: border-box; // 防止padding导致溢出
  
  
  .order_mark_item {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%; // 确保容器占满宽度
     min-width: 0; // 【关键】在Flex布局中，这允许子元素正确收缩和换行
    
    .remark-content {
      width: 100%;
      min-height: 20px;
      color: #333;
      font-size: 14px;
      line-height: 1.5; // 增加行高，提升长文本

       // 关键修改：处理长文本换行
      word-break: break-all;      // 允许在单词内换行
      word-wrap: break-word;      // 兼容旧浏览器
      white-space: pre-wrap;      // 保留换行符并自动换行
      overflow-wrap: break-word;  // 现代浏览器标准写法
    }
    
    .remark-time {
      margin-top: 8px;
      font-size: 12px;
      color: #999;
    }
  }
}
}
    
</style>